// @flow
import {FULFILLED} from 'redux-promise-middleware';

import {CHECKOUT} from 'constants/actions';
import type {AjaxActionType} from 'constants/flow/flowTypes';
import type {ShippingMethodType} from 'constants/flow/flowTypesCheckout';

import {getShippingMethodsAndTotalsApplePay} from 'reducers/applePayTotals/applePayTotals';

type ShippingMethodsType = {
    error: string,
    status: string,
    list: Array<ShippingMethodType>,
};

export const initialState = {
    list: [],
    error: 'success',
    status: '',
};

/**
 * Get current country region by country id
 *
 * @param {ShippingMethodsType} state Current state
 * @param {AjaxActionType} action Received action
 * @returns {ShippingMethodsType} List region
 */
export default function shippingMethod(
    state: ShippingMethodsType = initialState,
    action: AjaxActionType,
): ShippingMethodsType {
    switch (action.type) {
        case `${CHECKOUT.GET_SHIPPING_METHODS}_${FULFILLED}`:
            return {...state, status: 'fulfilled', list: action.payload.data};
        case `${getShippingMethodsAndTotalsApplePay}_${FULFILLED}`:
            return {...state, status: 'fulfilled', list: action.payload.data.shippingMethods};
        case CHECKOUT.SET_SHIPPING_METHODS:
            return {...state, status: 'fulfilled', list: action.payload};
        case 'SET_CURRENT_SHIPPING_ADDRESS':
            return {...initialState, status: 'pending'};
        case CHECKOUT.SET_SHIPPING_METHOD_ERROR: {
            return {...state, error: action.payload};
        }
        default:
            return state;
    }
}
